import * as React from 'react';
import { useState } from 'react';
import { Button } from 'antd';

import { AuthContext } from '../LocalAuthWrapper';
import Footer from './Footer';
import Navigation from './Navigation';

import './Layout.css';
import { BarsOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

type Props = {
  headerComponent?: React.ReactNode;
  children?: React.ReactNode;
};

function Layout(props: Props) {
  const defaultMenuVisible = JSON.parse(localStorage.getItem('tiro:layout:menuVisible') ?? 'true') as boolean;
  const [menuVisible, setMenuVisible] = useState<boolean>(defaultMenuVisible);
  const showMenu = () => {
    localStorage.setItem('tiro:layout:menuVisible', 'true');
    setMenuVisible(true);
  };
  const hideMenu = () => {
    localStorage.setItem('tiro:layout:menuVisible', 'false');
    setMenuVisible(false);
  };

  const { children, headerComponent } = props;

  return (
    <div className={'layout-container'}>
      <Navigation hideMenu={hideMenu} visible={menuVisible} />
      <header className={`header-container`}>
        <div className='header-title'>
          <Button onClick={showMenu} icon={<BarsOutlined />} tabIndex={-1} />
          <Link to='/'>
            <img src='/tiro_logo.png' alt='Tiro Logo' />
            <span className='brand-name'>Talgreinir</span>
          </Link>
        </div>
        <div className={'header-component'}>{headerComponent}</div>
        <div className='header-btns'>
          <a href='https://konto.is/tiro/16304e1af314ab2535a57885315234e9' target='_blank' rel='noopener noreferrer'>
            <button style={{ background: '#21ba25' }}>Viltu styrkja Tiro?</button>
          </a>
          <AuthContext.Consumer>
            {(value) => (
              <button style={{ background: 'grey' }} onClick={() => value.signOut()}>
                Skrá út
              </button>
            )}
          </AuthContext.Consumer>
        </div>
      </header>
      <div className={`layout-content-and-footer ${menuVisible ? 'menu-open' : null}`}>
        <div className={'layout-content'}>{children}</div>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
